/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {BaseLoginModule as ɵb,onAppInit as ɵa} from './index';